import { Component } from "@angular/core";
import { timer } from "rxjs/observable/timer";
import { ActionSheetController } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { ScoreBoardName } from "../scoreboard-by-name/scoreboard-by-name";
import { ModalController } from "ionic-angular";
import { IterableDiffers, DoCheck } from '@angular/core';

@Component({
    selector: 'race-by-name',
    templateUrl: 'race-by-name.html'
  })
  
export class RaceByName {
  athleteTimer: number = 0;
  interval;
  stopWatch = null;
  timerStarted: boolean = false;
  athletes: any = [];
  athletePlace = 0;
  selectedAth;
  shiftPressed: boolean = true;
  differ: any;

  constructor(private actionSheetCtrl: ActionSheetController,
              private translate: TranslateService, 
              private modalCtrl: ModalController,
              differs: IterableDiffers) {
                this.differ = differs.find([]).create(null);
              }


  transform(value: number){
    let time =  new Date(value * 1000).toISOString().substr(11,10);
    return time
  }

  ngDoCheck() {
    const change = this.differ.diff(this.athletes);
    
    this.sortArray();
    console.log("change");
    
  }

  sortArray(){
    let arr;

    arr = this.athletes.sort((a, b) => a.time > b.time && 1 || -1);
    for(let i = 0; i < arr.length; i++){
        arr[i].place = 0;
    }

    for(let i = 0; i < arr.length; i++){
        arr[i].place = i + 1;
    }

    console.log("arr sorted" + JSON.stringify(arr));
    
    this.athletes = arr;
  }

  startTimer() {
    if(!this.stopWatch){
        this.timerStarted = true;
        this.stopWatch = timer(0,100).subscribe(() => {
          this.athleteTimer += 0.1;
          // console.log("athlete timer " + this.athleteTimer);
        });
    } 
  }

  pauseTimer() {
      if(this.stopWatch){
        this.stopWatch.unsubscribe();
        this.stopWatch = null;
        this.timerStarted = false;
      }
  }

  restartTimer() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('RESTART_ROUND'),
      buttons: [
          {
              text: this.translate.instant('GLOBAL_YES'),
              handler: () => {
                this.shiftPressed = true;
                if(this.stopWatch){
                  this.stopWatch.unsubscribe();
                  this.stopWatch = null;
                  this.timerStarted = false;
                  this.athleteTimer = 0;
                  this.athletes.length = 0;
                  this.athletePlace = 0;
                }
                else{
                  this.timerStarted = false;
                  this.athleteTimer = 0;
                  this.athletes.length = 0;
                  this.athletePlace = 0;
                }
              }
          }, 
          {
              text: this.translate.instant('GLOBAL_NO'),
          }
      ]
    });
    actionSheet.present();
  }

  displayTimer() {
    return this.transform(this.athleteTimer);
  }

  recordAthTime() {
      if(this.timerStarted){
        let index = this.athletes.findIndex(i => i.isSelected == true);
        if(index == -1){
          this.athletePlace++;

          let athlete = {
            time: this.transform(this.athleteTimer), 
            place: this.athletePlace,
            isSelected: true,
            name: "", 
            bibNo: ""
          }
          this.athletes.push(athlete);
          this.selectedAth = this.athletes[0];
        }

        else if(index == 0){

          this.athletePlace++;

          let athlete = {
            time: this.transform(this.athleteTimer), 
            place: this.athletePlace,
            isSelected: true,
            name: "", 
            bibNo: ""
          }
          this.athletes.push(athlete);

          this.athletes[index].isSelected = false;
          this.selectedAth = this.athletes[index + 1];
        }

        else if(index == this.athletes.length - 1 && this.athletes.length != 0){
          this.athletePlace++;

          let athlete = {
            time: this.transform(this.athleteTimer), 
            place: this.athletePlace,
            isSelected: true,
            name: "", 
            bibNo: ""
          }

          this.athletes.push(athlete);
          this.athletes[index].isSelected = false;
          this.selectedAth = this.athletes[index + 1];
        }
        else{
          this.athletes[index].isSelected = false;
          this.athletes[index + 1].isSelected = true;
          this.selectedAth = this.athletes[index + 1];
        }
      }
  }

  enterNumPud() {
    let index = this.athletes.findIndex(i => i.isSelected == true);
    console.log("index " + index);

    if(index == 0 && this.athletes.length == 1){
      this.recordAthTime();
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else if(index == 0 && this.athletes.length > 1){
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else if(index == this.athletes.length - 1 && this.athletes.length != 0){
      this.recordAthTime();
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else if(index == -1 && this.timerStarted){
      this.recordAthTime();
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
    else{
      this.athletes[index].isSelected = false;
      this.athletes[index + 1].isSelected = true;
      this.selectedAth = this.athletes[index + 1];
    }
  }

  enterUserName(athlete){
    for(let i = 0; i < this.athletes.length; i++){
      this.athletes[i].isSelected = false;
    }

    if(athlete.isSelected){
        athlete.isSelected = false;
    }
    else{
        athlete.isSelected = true;
    }
    
    this.selectedAth = athlete;
  }

  pressShift(){
    this.shiftPressed = !this.shiftPressed;
  }

  enterLetter(l: string){

    if(this.selectedAth.name.length > 20){
      this.selectedAth.name += l;
      this.deleteLetter();
    }
    else{
      if(this.shiftPressed){
        this.selectedAth.name += l.toUpperCase();
        this.shiftPressed = !this.shiftPressed;
      }
      else{
        this.selectedAth.name += l;
      }
    }
    
    console.log("name length" + this.selectedAth.name.length);
  }

  deleteLetter(){
    let string = this.selectedAth.name.slice(0, -1);
    this.selectedAth.name = string;

    if(this.selectedAth.name.length == 0){
      this.shiftPressed = true;
    }
  }

  spaceButton(){
    this.selectedAth.name += " ";
    this.shiftPressed = true;
  }

  openScoreboardByName(){
    let modal = this.modalCtrl.create(ScoreBoardName, {arr: this.athletes});
    modal.present();
    console.log("score board");
  }
}


// WEBPACK FOOTER //
// /src/components/race-by-name-component/race-by-name.ts